import React from "react";
import { Link, useLocation } from "react-router-dom";
import { createPageUrl } from "./utils";
import { Sparkles, Phone, Mail, Instagram, Facebook, MapPin, X, Menu } from "lucide-react";
import ChatBot from './components/ChatBot'
import BookingModal from "./components/BookingModal";
import ReviewWidget from "./components/ReviewWidget";
import SeoSchema from "./components/SeoSchema";
import { Outlet } from "react-router-dom";
import TermsOfService from "./pages/TermsOfService";
import LoadingScreen from "./components/LoadingScreen";
import { FaSnapchatGhost, FaTiktok, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { SiX } from "react-icons/si"; // Si = Simple Icons
export default function Layout({ children, currentPageName }) {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = React.useState(false);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [isBookingOpen, setIsBookingOpen] = React.useState(false);
  const [initialService, setInitialService] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);
  const [showToast, setShowToast] = React.useState(false);
  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };

    const scrollHandler = (e) => handleScroll();
    window.addEventListener('scroll', scrollHandler, { passive: true });

    const openBookingModal = () => {
      setInitialService(null);
      setIsBookingOpen(true);
    };
    
    const openBookingModalWithService = (event) => {
      setInitialService(event.detail.service);
      setIsBookingOpen(true);
    };

    window.addEventListener('open-booking-modal', openBookingModal);
    window.addEventListener('open-booking-modal-with-service', openBookingModalWithService);

    return () => {
      window.removeEventListener('scroll', scrollHandler);
      window.removeEventListener('open-booking-modal', openBookingModal);
      window.removeEventListener('open-booking-modal-with-service', openBookingModalWithService);
    };
  }, []);

  const handleLoadingComplete = React.useCallback(() => {
    setIsLoading(false);
  }, []);

  const handleCloseBookingModal = React.useCallback(() => {
    setIsBookingOpen(false);
    setInitialService(null);
  }, []);

  const handleNewsletterSubmit = async (e) => {
  e.preventDefault();

  const email = e.target.email.value;

  const res = await fetch("https://zan-mkt.com/api/newsletter.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({ email }),
  });

  const data = await res.json();
setShowToast(true);
setTimeout(() => setShowToast(false), 3000);
};

  const navigationItems = React.useMemo(() => [
    { name: "الرئيسية", url: "/" },
    { name: "من نحـن", url: createPageUrl("Gallery") },
    { name: "خدمـاتنا", url: createPageUrl("Services") },
    // { name: "فريقـنا", url: createPageUrl("Team") },
    { name: "تـواصل معنا", url: createPageUrl("Contact") }
  ], []);

  // Add admin link only if URL contains admin parameter OR if accessing AdminBookings page
  const isAdminMode = React.useMemo(() => {
    return location.search.includes('admin=true') || 
           location.pathname.includes('admin') ||
           location.pathname.includes('AdminBookings') ||
           currentPageName === 'AdminBookings';
  }, [location.pathname, location.search, currentPageName]);

  const adminNavigationItems = React.useMemo(() => [
    ...navigationItems,
    ...(isAdminMode ? [{ name: "Admin Bookings", url: createPageUrl("AdminBookings") }] : [])
  ], [navigationItems, isAdminMode]);

  const currentNavItems = isAdminMode ? adminNavigationItems : navigationItems;

  if (isLoading) {
    return <LoadingScreen onLoadingComplete={handleLoadingComplete} />;
  }

  return (
    <div className="min-h-screen bg-[#F8F2EC] font-cairo text-[length:var(--font-body)] leading-[1.618]">
      <style>{`
        :root {
          --obsidian: #0F0F0F;
          --shell: #F8F2EC;
          --champagne: #141d3c;
          --coral: #fafcfa;
          --font-h1: clamp(2.5rem, 5vw, 4rem);
          --font-h2: clamp(1.75rem, 3.5vw, 2.75rem);
          --font-body: clamp(1rem, 1.6vw, 1.125rem);
        }
        @keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(100px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-slideIn {
  animation: slideIn 0.4s ease-out;
}
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500&family=Lato:wght@300;400&display=swap');
        
        * {
          box-sizing: border-box;
        }
        
        body {
          text-rendering: optimizeLegibility;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          font-display: swap;
        }

        .font-serif { font-family: 'Playfair Display', serif; }
        .font-sans { font-family: 'Lato', sans-serif; }
        
       .glass-nav {
  backdrop-filter: blur(20px);
  background: rgba(0, 0, 0, 0.1); /* أسود غامق + 60% شفافية */
  border-bottom: 1px solid rgba(255, 255, 255, 0.1); /* خفيف للحدود */
}

        
        .nav-transition {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          will-change: transform, opacity;
        }
        
        .sparkle-animation {
          animation: sparkle 3s ease-in-out infinite;
        }
        
        @keyframes sparkle {
          0%, 100% { opacity: 0.6; transform: scale(1) rotate(0deg); }
          50% { opacity: 1; transform: scale(1.1) rotate(180deg); }
        }
        
        .glow-text {
          text-shadow: 0 0 20px rgba(200, 168, 130, 0.3);
        }

       .text-shadow-dark {
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.9);
}
        .text-shadow-light {
text-shadow: 0 2px 6px rgba(255, 255, 255, 0.844);
}
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeInUp {
          animation: fadeInUp 0.5s ease-out forwards;
        }
        @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700&display=swap');

.font-cairo {
  font-family: 'Cairo', sans-serif;
}
        /* Performance optimizations */
        .motion-reduce {
          animation: none !important;
          transition: none !important;
        }
        
        @media (prefers-reduced-motion: reduce) {
          * {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.01ms !important;
          }
        }

        /* Image optimization */
        img {
          image-rendering: -webkit-optimize-contrast;
          image-rendering: optimize-contrast;
        }

        @media (max-width: 375px) {
          button[class*="bg-gradient-to-r"],
          button[class*="bg-[#141d3c]"],
          button[class*="bg-black/80"] {
            min-height: 44px;
            padding: 0.75rem 1.25rem !important;
            font-size: clamp(0.9rem, 4.5vw, 1rem) !important;
            max-width: 100%;
            height: auto;
            white-space: normal;
            line-height: 1.3;
            text-align: center;
          }
          
          button[class*="bg-gradient-to-r"] {
            padding: 1rem 1.5rem !important;
          }
        }
      `}</style>
      
      <SeoSchema />

      {/* Navigation with improved accessibility */}
      <nav 
        className={` fixed top-0 left-0 right-0 z-50 nav-transition ${
          isScrolled || isMenuOpen ? 'glass-nav py-4' : 'bg-transparent py-6'
        }`}
        role="navigation"
        aria-label="Main navigation"
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between pt-4">
            {/* Logo with improved accessibility */}
   <Link 
  to="/" 
  className="flex items-center gap-0 group transform transition-transform hover:scale-105"
  aria-label="SERENITY Spa & Salon - Go to homepage"
>
  <div className="flex flex-col justify-center -ml-8">
    <h1 className="text-[#141d3c] font-light text-[clamp(1rem,3vw,2rem)] glow-text text-center">
      ZAN
    </h1>
    <p className="text-xs text-center tracking-widest text-[#141d3c]">
      DIGITAL MARKETING
    </p>
  </div>

  <div className="relative w-32 h-24 md:w-30 md:h-32">
   <video
  autoPlay
  loop
  muted
  playsInline
  preload="auto"
  disablePictureInPicture
  onCanPlay={(e) => e.target.play().catch(() => {})}
>
  <source src="/videos/شعار زان 2.webm" type="video/webm" />
  <source src="/videos/شعار زان.mp4" type="video/mp4" />
</video>
  </div>

</Link>



            {/* Desktop Navigation with improved accessibility */}
            <div className="hidden lg:flex items-center gap-8" role="menubar">
              {currentNavItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.url}
                  role="menuitem"
                  className={`font-cairo text-2xl font-bold transition-all duration-300 hover:text-[#141d3c] relative group ${
                    location.pathname === item.url 
                      ? 'text-[#141d3c] text-shadow-light' 
                      : (isScrolled || isMenuOpen ? 'text-[#141d3c]' : 'text-white text-shadow-dark')
                  }`}
                  aria-current={location.pathname === item.url ? 'page' : undefined}
                >
                  {item.name}
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-[#141d3c] transition-all duration-300 group-hover:w-full" aria-hidden="true" />
                </Link>
              ))}
            </div>

            {/* CTA Button with improved accessibility */}
            <div className="hidden lg:block">
              <button 
                onClick={() => window.dispatchEvent(new CustomEvent('open-booking-modal'))}
                className="font-cairo bg-[#141d3c] text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#ee9805] transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-[#141d3c] focus:ring-offset-2"
                aria-label="Open booking appointment modal"
              >
اطلب عرضك الخاص               </button>
            </div>

            {/* Mobile Menu Button with improved accessibility */}
            <button 
              className={`lg:hidden p-2 z-50 focus:outline-none focus:ring-2 focus:ring-[#ee9805] focus:ring-offset-2 rounded ${isScrolled || isMenuOpen ? 'text-[#0F0F0F]' : 'text-white text-shadow-dark'}`} 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-expanded={isMenuOpen}
              aria-controls="mobile-menu"
              aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </nav>
      
      {/* Mobile Menu Overlay with improved accessibility */}
      {isMenuOpen && (
        <div 
          id="mobile-menu"
          className="fixed inset-0 bg-[#e8e9eb] backdrop-blur-lg z-40 flex flex-col items-center justify-center lg:hidden"
          role="dialog"
          aria-modal="true"
          aria-label="Mobile navigation menu"
        >
          <div className="flex flex-col items-center gap-8">
            {currentNavItems.map((item) => (
              <Link
                key={item.name}
                to={item.url}
                onClick={() => setIsMenuOpen(false)}
                className={`text-2xl font-medium transition-all duration-300 hover:text-[#ee9805] focus:outline-none focus:ring-2 focus:ring-[#141d3c] focus:ring-offset-2 rounded px-2 py-1 ${
                  location.pathname === item.url ? 'text-[#ee9805]' : 'text-[#0F0F0F]'
                }`}
                aria-current={location.pathname === item.url ? 'page' : undefined}
              >
                {item.name}
              </Link>
            ))}
             <button 
                onClick={() => {
                  setIsMenuOpen(false);
                  window.dispatchEvent(new CustomEvent('open-booking-modal'));
                }}
                className="font-cairo mt-8 bg-[#141d3c] text-white px-8 py-4 rounded-full text-lg font-medium hover:bg-[#0F0F0F] transition-all duration-300 hover:scale-105 shadow-lg focus:outline-none focus:ring-2 focus:ring-[#141d3c] focus:ring-offset-2"
                aria-label="Open booking appointment modal"
              >
اطلب عرضك الخاص               </button>
          </div>
        </div>
      )}

      {/* Main Content with improved accessibility */}
      <main className="relative" role="main">
<Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-[#0F0F0F] text-white relative overflow-hidden" role="contentinfo">
        <div className="absolute inset-0 bg-gradient-to-r from-[#0F0F0F] via-[#1a1a1a] to-[#0F0F0F]" aria-hidden="true" />
        
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-16">
          {/* Brand */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-[clamp(1rem,2vw,2.5rem)] text-center md:text-left">
            <div className="lg:col-span-1 flex flex-col items-center md:items-start mb-[1.2em]">
              <div className="flex items-center gap-3 mb-6">
          <img 
          src="/logoW.png" 
          alt="Icon"
          className="w-20 h-16"
          />
                <div>
<h2 className="font-sans text-2xl font-normal text-white" style={{ textDecoration: 'underline', textDecorationColor: '#ee9805' }}>
  ZAN DIGITAL MARKETING
</h2>


                  <p className="text-xs text-[#141d3c] tracking-widest"></p>
                </div>
              </div>
             <p className="font-cairo text-right text-sm leading-[1.618] text-gray-300 mb-6">
  زان شركة سعودية رائدة في التسويق والإعلان منذ عام 2012، تقدّم منظومة متكاملة 
  من الخدمات الإبداعية تشمل الهوية البصرية، الحملات الرقمية، الإنتاج الإعلامي، 
  والطباعة. نصنع حضورًا مؤثرًا للعلامات التجارية ونحوّل الأفكار إلى تجارب تُلهم.
</p>

             <div className="flex gap-4" role="list" aria-label="Social media links">

  {/* Instagram */}
  <a 
    href="https://www.instagram.com/zan_mkt" 
    target="_blank"
    rel="noopener noreferrer"
    className="w-10 h-10 bg-[#ee9805] rounded-full flex items-center justify-center hover:bg-[#ee9805]/50 transition-colors duration-300"
    aria-label="Instagram"
  >
    <Instagram className="w-5 h-5" />
  </a>

  {/* Snapchat */}
  <a 
    href="https://snapchat.com/t/b6iUvDS1" 
    target="_blank"
    rel="noopener noreferrer"
    className="w-10 h-10 bg-[#ee9805] rounded-full flex items-center justify-center hover:bg-[#ee9805]/50 transition-colors duration-300"
    aria-label="Snapchat"
  >
    <FaSnapchatGhost className="w-5 h-5" />
  </a>

  {/* YouTube (حطي رابطك إذا توفر) */}
  <a 
    href="#" 
    className="w-10 h-10 bg-[#ee9805] rounded-full flex items-center justify-center hover:bg-[#ee9805]/50 transition-colors duration-300"
    aria-label="YouTube"
  >
    <FaYoutube className="w-5 h-5" />
  </a>

  {/* TikTok */}
  <a 
    href="https://www.tiktok.com/@zan.mkt" 
    target="_blank"
    rel="noopener noreferrer"
    className="w-10 h-10 bg-[#ee9805] rounded-full flex items-center justify-center hover:bg-[#ee9805]/50 transition-colors duration-300"
    aria-label="TikTok"
  >
    <FaTiktok className="w-5 h-5" />
  </a>

  {/* X (تويتر سابقاً) */}
  <a 
    href="https://x.com/zan_mkt" 
    target="_blank"
    rel="noopener noreferrer"
    className="w-10 h-10 bg-[#ee9805] rounded-full flex items-center justify-center hover:bg-[#ee9805]/50 transition-colors duration-300"
    aria-label="X"
  >
    <SiX className="w-5 h-5" />
  </a>

  {/* WhatsApp */}
  <a 
    href="https://wa.me/966579379779" 
    target="_blank"
    rel="noopener noreferrer"
    className="w-10 h-10 bg-[#ee9805] rounded-full flex items-center justify-center hover:bg-[#ee9805]/50 transition-colors duration-300"
    aria-label="WhatsApp"
  >
    <FaWhatsapp className="w-5 h-5" />
  </a>
  </div>
</div>
            {/* Services */}
            <div className="mb-[1.2em]">
              <h3 className="font-cairo text-right text-lg font-semibold mb-6 text-[#ee9805]">خـدمـاتـنـا</h3>
              <nav aria-label="Services navigation">
               <ul className="text-right space-y-3 text-sm">
  <li>
    <Link
      to="/services?category=تسويق"
      className="font-cairo text-gray-300 hover:text-[#ee9805] transition-colors"
    >
      التسويـق الرقمـي
    </Link>
  </li>

  <li>
    <Link
      to="/services?category=استشارات"
      className="font-cairo text-gray-300 hover:text-[#ee9805] transition-colors"
    >
      الاستشارات التسويقيـة
    </Link>
  </li>

  <li>
    <Link
      to="/services?category=تنظيم فعاليات"
      className="font-cairo text-gray-300 hover:text-[#ee9805] transition-colors"
    >
      تنظيـم الفعاليـات والإيفنتات
    </Link>
  </li>
  
  <li>
    <Link
      to="/services?category=تصميم"
      className="font-cairo text-gray-300 hover:text-[#ee9805] transition-colors"
    >
      الهوية البصرية والعلامة التجارية
    </Link>
  </li>

  <li>
    <Link
      to="/services?category=طباعه"
      className="font-cairo text-gray-300 hover:text-[#ee9805] transition-colors"
    >
      الطباعة والإنتاج المطبعي
    </Link>
  </li>

  <li>
    <Link
      to="/services?category=تصوير"
      className="font-cairo text-gray-300 hover:text-[#ee9805] transition-colors"
    >
      الإنتاج الإعلامي والتصوير
    </Link>
  </li>
</ul>

              </nav>
            </div>

            {/* Contact */}
            <div className="mb-[1.2em]">
              <h3 className="font-cairo text-right text-lg font-semibold mb-6 text-[#ee9805]">مـوقـعنـا</h3>
              <address className="space-y-4 text-sm flex flex-col items-center md:items-start not-italic">
                <div className="text-right flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-[#ee9805] mt-0.5 flex-shrink-0" aria-hidden="true" />
 <p className="font-cairo leading-[1.618] text-gray-300">
  <strong>الإدارة الرئيسية :</strong> <br /> جدة – التحلية – شارع الحارث بن العاص <br />
  <strong>الفروع :</strong> <br />
  • القنفذة / الناعمية - طريق الملك فيصل بن عبدالعزيز <br />
  • جازان / فرع المنطقة الجنوبية (قريبًا 2026)
</p>                </div>
                <div className="flex items-center gap-3">
                  <Phone className="w-5 h-5 text-[#ee9805]" aria-hidden="true" />
                  <a href="tel:+966579379779" className="text-gray-300 hover:text-[#EE9805] transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-[#141d3c] focus:ring-offset-2 focus:ring-offset-[#141D3C] rounded"> ⁦+966 57 937 9779⁩ </a>
                </div>
                <div className="flex items-center gap-3">
                  <Mail className="w-5 h-5 text-[#ee9805]" aria-hidden="true" />
                  <a href="mailto:info@zan-mkt.com" className="text-gray-300 hover:text-[#EE9805] transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-[#141d3c] focus:ring-offset-2 focus:ring-offset-[#141D3C] rounded">info@zan-mkt.com</a>
                </div>
              </address>
            </div>

            {/* Newsletter */}
            <div className="mb-[1.2em]">
            
              <h3 className="font-cairo text-right text-lg font-semibold mb-6 text-[#ee9805]">الـنـشـرات الإخـبـاريـة</h3>
              <p className="text-sm text-right font-cairo text-gray-300 mb-4 leading-[1.618]">
اشترك الآن للحصول على عروض حصرية وأحدث الخدمات والنصائح التسويقية من زان
              </p>
<form
  onSubmit={handleNewsletterSubmit}
  className="font-cairo flex flex-col sm:flex-row gap-2 max-w-sm mx-auto md:max-w-none"
  aria-label="Newsletter subscription"
>
                <label htmlFor="newsletter-email" className="sr-only">Email address</label>
                <input
                  name="email"   // 👈 هذا السطر الجديد (مهم جدًا)
                  id="newsletter-email"
                  type="email"
                  placeholder="بـريـدك الإلـكـتـرونـي"
                  className="text-center flex-1 px-4 py-2 bg-white/10 border border-[#ee9805]/30 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-[#141d3c] focus:ring-2 focus:ring-[#141d3c] focus:ring-offset-2 focus:ring-offset-[#0F0F0F]"
                  required
                />
                <button 
                  type="submit"
                  className="text-center px-4 py-2 bg-[#ee9805] text-white rounded-lg hover:bg-[#ee9805]/50 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-[#141d3c] focus:ring-offset-2 focus:ring-offset-[#0F0F0F]"
                >
اشـتـراك                </button>
              </form>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-12 pt-8 border-t border-[#ee9805] flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-cairo text-right text-sm text-gray-400">
  © 2026 زان التسويقية الرقمية. جميع الحقوق محفوظة.
            </p>
            
            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6">
              <nav aria-label="Legal links">
                <div className="flex gap-6 text-sm">
                  
<Link
  to="/terms-of-service"
  className="font-cairo text-gray-400 hover:text-[#ee9805] transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-[#141d3c] focus:ring-offset-2 focus:ring-offset-[#0F0F0F] rounded"
>
شروط الإستخـدام </Link>   
<Link
  to="/privacy-policy"
  className="font-cairo text-gray-400 hover:text-[#ee9805] transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-[#141d3c] focus:ring-offset-2 focus:ring-offset-[#0F0F0F] rounded"
>
سياسة الخصوصية </Link>             
                </div>
              </nav>
              
              {/* Digital Doctors Attribution */}
              <div className="text-xs text-gray-500">
                Created by: <span className="text-[#ee9805] hover:text-white transition-colors duration-300">MASAR HADAF</span>, +966 55 974 9459
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Components */}
      <ChatBot />
      <ReviewWidget />
      <BookingModal 
        isOpen={isBookingOpen} 
        onClose={handleCloseBookingModal}
        initialService={initialService} 
      />
    {showToast && (
  <div className="fixed bottom-6 right-6 z-50 animate-slideIn">
    <div className="bg-[#141d3c] text-white px-8 py-5 rounded-2xl shadow-2xl flex items-center gap-4 border border-[#ee9805]">
      

      <div>
        <p className="font-cairo text-lg font-bold">تـم الاشتـراك بنجـاح</p>
      </div>

    </div>
  </div>
)}
    </div>);
}
